var module = angular.module('octopusApp.projects');


module.controller('ProjectVariablesController', function($scope, $timeout, busy, projectState, pageTitle, octopusRepository,
                                                         $location, unsavedChanges, octopusPermissionSet, scopeValuesToScopeOptionsConverter) {
    var isLoading = $scope.isLoading = busy.create();
    var isSaving = $scope.isSaving = busy.create();
    var projectId = projectState.projectId;

    $scope.canSave = false;
    $scope.canSaveProject = false;

    $scope.save = function() {
        if ($scope.canSaveProject) {
            octopusRepository.Projects.modify($scope.project).then(function(modified) {
                $scope.canSaveProject = false;
                if ($scope.canSave) {
                    $scope.$broadcast("variableEditor:applyChanges", $scope.variableSet);
                } else {
                    unsavedChanges.saved();
                }
            });
        } else {
            $scope.$broadcast("variableEditor:applyChanges", $scope.variableSet);
        }
    };
    $scope.$on("variableEditor:changesApplied", function(e, vs) {
        isSaving.promise(octopusRepository.Variables.modify(vs).then(function() {
            unsavedChanges.saved();
            load();
        }));
    });

    $scope.$on("variableEditor:dirty", function(e, vs) {
        $scope.canSave = true;
        unsavedChanges.unsaved();
    });

    $scope.$on("variableEditor:clean", function(e, vs) {
        $scope.canSave = false;
        unsavedChanges.saved();
    });

    var load = function() {
        isLoading.promise(projectState.load().then(function(project) {
            pageTitle(project.Name + " variables");

            octopusRepository.LibraryVariableSets.all({ids: project.IncludedLibraryVariableSetIds, contentType: 'Variables'}).then(function (libraryVariableSets) {
            $scope.libraryVariableSetCount = libraryVariableSets.length;
        });

            $scope.project = project;

            isLoading.promise(octopusPermissionSet.isAuthorized({
                permission: 'VariableEdit',
                projectId: project.Id,
                environmentId: '*'
            }).then(function(yn) {
                isLoading.promise(octopusRepository.Variables.get(project.VariableSetId).then(function(variableSet) {
                    $scope.variableSet = variableSet;

                    $scope.variableEditorOptions = {
                        variableSet: variableSet,
                        scopeOptions: scopeValuesToScopeOptionsConverter(variableSet.ScopeValues),
                        canEdit: yn,
                        canScopeToTenantTags: project.TenantedDeploymentMode !== 'Untenanted'
                    };

                    delayVariableEditor();
                }));
            }));
        }));
    };

    function delayVariableEditor() {
        $timeout(function() {
            $scope.showVariableEditor = true;
        }, 100);
    }

    load();
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/variables/project_variables.js
// module id = 574
// module chunks = 1